import restClient from "../restClient";

export const getAllSAInventories = async (search, status, location, altLocation, page, pageSize, options = {}, tableFilters = {}, tenant) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`sa/inventories`, { ...config, params: { search, status, location, altLocation, page, pageSize, tableFilters, tenant } });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getAllSADeals = async (search, status, location, altLocation, page, pageSize, tenant) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`sa/deals`, { ...config, params: { search, status, page, pageSize, tenant } });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getAllSACalculus = async (search, status, page, pageSize, tenant) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`sa/calculus`, { ...config, params: { search, status, page, pageSize, tenant } });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getSAUsers = async (page, pageSize, tenant, search) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        "pagination[page]": page,
        "pagination[pageSize]": pageSize,
        "tenant": tenant,
        "search": search
      }
    };
    const response = await restClient.get(`sa/users`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getTenantRoles = async (tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.get(`sa/tenant/user-roles/${tenantId}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getTenants = async (page, pageSize, search = '', status = 'all') => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        "pagination[page]": page,
        "pagination[pageSize]": pageSize,
      }
    };

    if (search) {
      config.params.search = search;
    }

    if (status !== 'all') {
      config.params.status = status;
    }

    const response = await restClient.get(`sa/tenants`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getTenant = async (id, type = null, page = 1, pageSize = 10, additionalParams = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        ...additionalParams,
        "pagination[page]": page,
        "pagination[pageSize]": pageSize,
      }
    };

    if (type) {
      config.params.type = type;
    }

    const response = await restClient.get(`sa/tenant/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getTenantUserDetail = async (id, tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.get(`sa/user-detail/${id}?tenantId=${tenantId}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createCompany = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`admin/create-company`, { data: formData }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createTenantAdmin = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`sa/new-tenant`, { data: formData }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const createTenantUser = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`sa/tenant/user`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateTenant = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.put(`sa/tenant/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUserDetail = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.get(`sa/user-detail/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateUser = async (tenantId, id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`sa/user/${id}?tenantId=${tenantId}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteUser = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`sa/user/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getTaxesAndFees = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`tax-and-fees`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getTaxeAndFee = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`tax-and-fees/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createTaxAndFee = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`tax-and-fees`, { data: formData }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};




export const updateTaxAndFee = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`tax-and-fees/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getSALogs = async (page, pageSize, userId, tenant) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        "pagination[page]": page,
        "pagination[pageSize]": pageSize,
        userId,
        tenant
      }
    };
    const response = await restClient.get(`sa/logs`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteTaxAndFee = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`tax-and-fees/${id}`, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const saAuthConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

export const getAppIntegrations = async (tenant) => {
  const response = await restClient.get(`sa/app-integrations`, {
    ...saAuthConfig(),
    params: tenant ? { tenant } : {},
  });
  return response.data;
};

export const getAppIntegrationApiCatalog = async () => {
  const response = await restClient.get(`sa/app-integrations/api-catalog`, saAuthConfig());
  return response.data;
};

export const createAppIntegration = async (data) => {
  const response = await restClient.post(`sa/app-integrations`, { data }, saAuthConfig());
  return response.data;
};

export const updateAppIntegration = async (id, data) => {
  const response = await restClient.put(`sa/app-integrations/${id}`, { data }, saAuthConfig());
  return response.data;
};

export const rotateAppIntegrationSecret = async (id) => {
  const response = await restClient.post(
    `sa/app-integrations/${id}/rotate-secret`,
    {},
    saAuthConfig()
  );
  return response.data;
};

export const getAppIntegrationUsers = async (id) => {
  const response = await restClient.get(`sa/app-integrations/${id}/users`, saAuthConfig());
  return response.data;
};

export const issueAppIntegrationUserToken = async (id, data) => {
  const response = await restClient.post(
    `sa/app-integrations/${id}/issue-user-token`,
    { data },
    saAuthConfig()
  );
  return response.data;
};